export const THEME_COLOR_DARK = '#f07911';
export const THEME_COLOR_LIGHT = '#f39441';
export const THEME_COLOR_TINT = '#fbd7b8';

export const PAYMENT_METHODS = [
    { key: 'net', value: 'NET' },
    { key: 'meezan_bank', value: 'Meezan Bank' },
    { key: 'jazz_cash', value: 'JazzCash' },
    { key: 'easy_paisa', value: 'EasyPaisa' },
    { key: 'u_paisa', value: 'U-Paisa' },
    { key: 'naya_paisa', value: 'NayaPay' },
    { key: 'sada_pay', value: 'SadaPay' },
    { key: 'other', value: 'Other' },
    { key: 'cheque', value: 'Cheque' },
    { key: 'pending', value: 'Pending' }
];

export const STAFF_TYPES = {
    admin: 'superadmin',
    staff: 'staff'
};
